import { CustomAxiosError, WorkflowWorkflowInfo } from '@calm/evexia-web-sdk';
import { useMutation } from '@rhg/libs/react-query';
import { useActiveCircle } from '../use-active-circle';
import { useStartWorkflow } from '../use-start-workflow';
import { useFetchWorkflowNextStep } from '../use-workflow-next-step';

export interface JoinWorkflowParameters {
    workflow?: WorkflowWorkflowInfo;
}
export function useJoinWorkflow() {
    const { activeCircle } = useActiveCircle();
    const { startWorkflowAsync } = useStartWorkflow();
    const { fetchWorkflowNextStepAsync } = useFetchWorkflowNextStep();
    const { mutate, mutateAsync, ...otherProps } = useMutation({
        mutationFn: async ({ workflow }: JoinWorkflowParameters) => {
            const workflowDefnId = workflow?.workflowDefn?.defnId;
            const workflowType = workflow?.workflowDefn?.type;
            if (workflowDefnId) {
                await startWorkflowAsync({ workflowDefnId, workflowType });
                return await fetchWorkflowNextStepAsync({
                    workflowDefnId,
                    workflowType,
                    circle: activeCircle!,
                });
            } else {
                throw { response: { status: 404 } } as CustomAxiosError;
            }
        },
    });
    return {
        joinWorkflow: mutate,
        joinWorkflowAsync: mutateAsync,
        ...otherProps,
    };
}
